import { PageLayout, TopNavigation } from '@atlaskit/page-layout';
import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { RouteComponent } from 'react-resource-router';

import { useHelp } from '@townsquare/navigation';
import { BetterUpdatesChangeboarding } from '@townsquare/onboarding/better-updates';
import { SiteBannerProvider } from '@townsquare/site-banner';

import { DefaultLayout } from '../layouts/Default/DefaultLayout';
import { HomeLayout } from '../layouts/Home/HomeLayout';
import { Navigation } from '../navigation/Navigation';

import { useRoute } from './hooks';

const styles = xcss({ position: 'absolute', zIndex: 'navigation', insetInlineEnd: 'space.0' });

export function Route() {
  const { layout } = useRoute();
  const { isOpen: isHelpOpen } = useHelp();

  const Layout = layout === 'home' ? HomeLayout : DefaultLayout;

  return (
    <>
      <PageLayout>
        <SiteBannerProvider>
          <TopNavigation isFixed>
            <Navigation />
          </TopNavigation>
          <Layout>
            {isHelpOpen && (
              <>
                {/* Add anchor for help-panel to attach to */}
                <Box xcss={styles} id="help-panel" />
              </>
            )}
            <RouteComponent />
          </Layout>
        </SiteBannerProvider>
      </PageLayout>
      <BetterUpdatesChangeboarding />
    </>
  );
}
